import { PageHeader } from '@/components/shared/page-header';
import { TableSkeleton } from '@/components/shared/skeleton';

export function Loading() {
  return (
    <>
      <PageHeader title="Companies" description="Manage operating companies and profiles" />
      <TableSkeleton columns={5} />
    </>
  );
}
